import { useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"

/**
 * Navigate once when mounted, replacing the current entry. Unlike rendering `<Navigate>` from a
 * component that also subscribes to router state, this cannot re-trigger itself on every render
 * while the navigation is pending (which loops until the page runs out of memory).
 */
export function RedirectOnce({ to, search }: { to: string; search?: Record<string, string> }) {
  const navigate = useNavigate()
  useEffect(() => {
    void navigate({ to, ...(search ? { search } : {}), replace: true })
    // Exactly once per mount: the target is decided by the render that mounted this redirect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}
